const active = (v) => v && !v.deleted && v.status !== "停用";
export function attributeCatalog(setting) {
  const categories = (
    Array.isArray(setting?.categories) ? setting.categories : []
  )
    .filter(active)
    .map((c) => ({
      id: String(c.id),
      name: String(c.name),
      sort: Number(c.sort) || 0,
    }))
    .sort((a, b) => a.sort - b.sort);
  const attributes = (
    Array.isArray(setting?.attributes) ? setting.attributes : []
  )
    .filter(
      (a) =>
        active(a) &&
        a.searchable !== false &&
        categories.some((c) => c.id === a.categoryId),
    )
    .map((a) => ({
      id: String(a.id),
      name: String(a.name),
      categoryId: String(a.categoryId),
      sort: Number(a.sort) || 0,
    }))
    .sort((a, b) => a.sort - b.sort);
  return { categories, attributes };
}
export function navigationAttributeErrors(menu, setting) {
  if (menu.targetType !== "categories") return [];
  const { categories, attributes } = attributeCatalog(setting),
    selected = menu.attributeCategoryIds || [],
    ids = menu.attributeIds || [];
  const errors = [];
  for (const id of selected) {
    if (!categories.some((c) => c.id === id))
      errors.push(`菜单“${menu.name}”的属性分类已删除或停用，请重新选择`);
    else if (!attributes.some((a) => a.categoryId === id))
      errors.push(`菜单“${menu.name}”的属性分类没有可筛选的启用属性`);
  }
  for (const id of ids)
    if (!attributes.some((a) => a.id === id && selected.includes(a.categoryId)))
      errors.push(
        `菜单“${menu.name}”的具体属性不可用或未选择对应分类，请重新选择`,
      );
  return [...new Set(errors)];
}
export function resolveAttributeFilters(menu, setting) {
  if (menu.targetType !== "categories") return [];
  const { categories, attributes } = attributeCatalog(setting);
  const invalid = (menu.attributeIds || []).some(
    (id) => !attributes.some((a) => a.id === id),
  );
  return (menu.attributeCategoryIds || []).map((id) => {
    const all = attributes.filter((a) => a.categoryId === id),
      chosen = (menu.attributeIds || []).filter((aid) =>
        all.some((a) => a.id === aid),
      );
    // Explicit IDs that became unavailable must never widen a saved filter.
    const originalIds = (
      Array.isArray(setting?.attributes) ? setting.attributes : []
    )
      .filter((a) => a.categoryId === id)
      .map((a) => a.id);
    const explicitlySelected = (menu.attributeIds || []).some((aid) =>
      originalIds.includes(aid),
    );
    const rows = invalid
      ? []
      : explicitlySelected
        ? all.filter((a) => chosen.includes(a.id))
        : all;
    return {
      categoryId: id,
      name: categories.find((c) => c.id === id)?.name || "不可用分类",
      attributeIds: rows.map((a) => a.id),
      names: rows.map((a) => a.name),
    };
  });
}
export function videoPropertyNames(video) {
  const raw =
    typeof video.property === "string"
      ? video.property
      : video.properties || [];
  const names = (Array.isArray(raw) ? raw : [raw])
    .flatMap((v) => (typeof v === "string" ? v.split(/\s*[·,，;；|]\s*/) : []))
    .map((v) => v.trim())
    .filter(Boolean);
  if (video.recommend === true) names.push("推荐");
  if (video.top === true) names.push("置顶");
  return [...new Set(names)];
}
export function matchesAttributeFilters(video, filters) {
  const names = videoPropertyNames(video);
  return (filters || []).every(
    (f) =>
      f.names.some((name) => names.includes(name)) ||
      (Array.isArray(video.attributeIds) &&
        f.attributeIds.some((id) => video.attributeIds.includes(id))),
  );
}
